// extracted by mini-css-extract-plugin
export var typingIndicator = "_rq-0";